<div class="verify-password-dialog">
  <sync-dialog [config]="
    {
      title: 'Confirm your password', 
      isClosable: true, 
      actionButton: 'Confirm', 
      cancelButton: 'Cancel',
      onActionClick: checkPassword,
      onCancelClick: closeDialog,
      isButtonLoading: isLoading
    }"
    [open]="showDialog"
    [isFullScreen]="false"
    [onClose]="closeDialog"
  >
    <div class="login-form">
      <app-error [errcode]="errcode"></app-error>
      <p>For security, confirm your account password to proceed with this account level change</p>
      <sync-text-field [inputType]="'password'" label="Password" placeholder="Password"
        [inputChange]="setPassword"></sync-text-field>
    </div>
  </sync-dialog>
</div>